var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"skg-quiz-modal"},[_c('div',{attrs:{"id":"wrapper","data-tf-inline-on-mobile":"","data-tf-medium":"snippet","data-tf-widget":"M7XLxHMz"}})])
}]

export { render, staticRenderFns }